import { Link } from "react-router-dom";
import { Reveal } from "../components/Reveal";
import { Seo } from "../components/Seo";
import { articles } from "../data/articles";

export const Blog = () => (
  <>
    <Seo
      title="Blog | Cocina Árabe y Marroquí — Yasmina Puigcerdà"
      description="Historias y recetas de cocina árabe y marroquí desde La Cerdanya: tagine, cuscús, té moruno y ras el hanout."
      path="/blog"
    />
    <section className="blog-hero">
      <div className="container">
        <Reveal><div className="label">Diario Yasmina</div></Reveal>
        <Reveal delay={1}>
          <h1>Historias, recetas y cultura marroquí.</h1>
        </Reveal>
        <Reveal delay={2}>
          <p style={{ maxWidth: 560, margin: "20px auto 0" }}>
            Todo lo que hay detrás de un tagine, de un té con menta y de una
            mesa donde nadie tiene prisa.
          </p>
        </Reveal>
      </div>
    </section>

    <div className="container">
      <div className="blog-grid" data-testid="blog-grid">
        {articles.map((a, i) => (
          <Reveal key={a.slug} delay={Math.min(3, i + 1)}>
            <Link to={`/blog/${a.slug}`} className="article-card" data-testid={`article-card-${a.slug}`}>
              <div className="cover" style={{ backgroundImage: `url(${a.cover})` }} aria-label={a.title} role="img" />
              <div className="body">
                <div className="meta">
                  {new Date(a.date).toLocaleDateString("es-ES", { day: "2-digit", month: "short", year: "numeric" })}
                  {" · "}{a.readingTime}
                </div>
                <h3>{a.title}</h3>
                <p>{a.excerpt}</p>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </>
);
